import { PaymentPlanEntryStatus, PaymentPlanStatus, } from '@debbie/common/dist/economy/payment-plans/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../theme.js';
import Badge from '../Badge.js';
import RefreshCcw from '../Icons/RefreshCcw.js';
export const PaymentPlanStatusBadge = ({ status, }) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Badge, { theme: status === PaymentPlanStatus.ACTIVE ? THEME.SUCCESS : 'grey', style: { margin: '0' } }, lang.paymentPlans[status]));
};
export const PaymentPlanProgress = ({ entries }) => {
    const lang = useSelector((s) => s.lang);
    const paid = entries.filter((entry) => entry.status === PaymentPlanEntryStatus.SETTLED).length;
    return (React.createElement("span", { title: lang.paymentPlanEntryStatuses[PaymentPlanEntryStatus.SETTLED] },
        React.createElement(RefreshCcw, { size: "1em", "aria-hidden": "true" }),
        " ",
        paid,
        "/",
        entries.length));
};
//# sourceMappingURL=PaymentPlanIndicators.js.map